<template>
  <div>
    <div class="body">
      <div v-if="!loading" class="filter-section">
        <!-- CRM FOR BULK PENDING -->
        <!-- <Crm-Export
          v-on:crmUpgradePopup="showUpgradePopup"
          :pageType="'Bulk'"
        />-->
        <div class="sel-all-section" v-if="isContactCheckBtn">
          <CheckBox
            id="selectAll"
            name="selectAll"
            :isChecked="selectContacts"
            :onValueChange="checkContactSelected"
            :data="{}"
            labelText="Select all with email"
          />
        </div>
      </div>
      <div v-else class="list-loader">
        <!-- CRM FOR BULK LOADER -->
        <!-- <Crm-Export-Loader v-if="false"/> -->
        <div class="list-loader-section">
          <div class="linear-background loader-check-box"></div>
          <div class="linear-background checkbox-label"></div>
        </div>
      </div>
      <Review-Popup
        v-if="showReviewPopup"
        v-on:reviewPopupClosed="showReviewPopup = false"
      />
      <Upgrade-Popup
        v-if="showPopup"
        :upgradePopupType="upgradePopupType"
        v-on:clickedOutside="showPopup = false"
      />
      <Activation-Popup
        v-if="showActivationPopup"
        v-on:closed="showActivationPopup = false"
      />
      <Credit-Limit-Popup
        v-if="showCreditLimitPopup"
        v-on:clickedOutside="showCreditLimitPopup = false"
      />
      <ul
        :class="{
          bulk__contact__List: true,
          no_space: !isContactCheckBtn
        }"
      >
        <li v-for="(ele, index) in profileList" :key="index">
          <div class="contact-card-section">
            <Contact-Card
              :fromBulk="true"
              :enableReviewPopup="enableReviewPopup"
              :showUpgradePopup="showUpgradePopup"
              :loading="loading"
              :profileData="getContactData(ele)"
              :requestId="requestId"
              :isContactCheckBtn="isContactCheckBtn"
              :showCheckBox="true"
              :canShowCheckBox="canShowCheckBox(ele)"
              :isChecked="
                getContactData(ele)
                  ? getCheckedContacts.indexOf(getContactData(ele).mcId) > -1
                  : false
              "
              :onValueChange="onValueChange"
              :findEmailCallback="findEmailCallback"
              :updateEmail="updateEmail"
              :updatePhone="updatePhone"
            />
          </div>
        </li>
        <div
          v-if="
            isContactCheckBtn &&
              profileList &&
              profileList.length >= 1 &&
              getCheckedContacts.length > 0
          "
          class="blur-li"
        >
          <div class="list-section">
            <Create-List
              :contactId="[]"
              :listType="'bulk'"
              :showActivationPopup="showActivationError"
            />
          </div>
          <V-Button
            :className="'bulk-get-email-but'"
            :callback="findAllEmail"
            text="Save"
            :loading="bulkLoader"
          />
        </div>
      </ul>
    </div>
    <!-- <Help-Section></Help-Section> -->
    <Linkedin-Connect-Popup
      v-if="showLinkedInConnect"
      v-on:success="
        showLinkedInConnect = false
        findAllEmail()
      "
      v-on:failed="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_multi')
      "
      v-on:close="showLinkedInConnect = false"
      v-on:skip="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_skip')
      "
    />
  </div>
</template>

<script>
import ContactCard from '@/components/ContactCard.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'
import { post } from './../assets/util/rest.js'
import sharedFunctions from '@/assets/util/functions.js'
import button from '@/components/Button'
import CreateList from '@/components/CreateList'
import UpgradePopup from '@/components/UpgradePopup.vue'
import Checkbox from '@/components/Checkbox.vue'
import sharedFunction from './../assets/util/functions.js'
import { MxEvent, HttpUrl } from './../assets/util/constants/analytics.js'
// import CreateListFloatingLabel from '@/components/CreatelistFloatingLabel'
import LinkedinConnectVue from '@/components/LinkedinConnect.vue'
// import CrmExport from '@/components/crmExport/CrmExport'
// import CrmExportLoader from '@/components/crmExport/CrmExportLoader'
// import helpSection from '@/components/help/Helpmenu.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import { checkAndShowG2ReviewPopup } from '@/assets/util/commonUtil.js'

export default {
  name: 'LinkedinBulk',
  props: ['profileData'],
  watch: {
    profileData: {
      immediate: true,
      handler(newValue, oldValue) {
        const { profiles: newProfiles = null } = newValue || {}
        const { profiles: oldProfiles = null } = oldValue || {}
        if (newProfiles && oldProfiles != newProfiles) {
          this.profileList = newProfiles
          this.enrichProfileData(newProfiles)
          this.trackBulkProfileLoad(newValue)
        }
      }
    }
  },
  computed: {
    isContactCheckBtn: function() {
      let contactEmailExist = 0
      if (!this.$store.state.linkedin.bulk.contacts) return null
      Object.values(this.$store.state.linkedin.bulk.contacts).forEach(c => {
        if (c.email) {
          contactEmailExist++
        }
      })
      return contactEmailExist > 0
    },
    totalContactExist: function() {
      let totalEmailExist = 0
      if (!this.$store.state.linkedin.bulk.contacts) return null
      Object.values(this.$store.state.linkedin.bulk.contacts).forEach(c => {
        if (c.email) {
          totalEmailExist++
        }
      })
      return totalEmailExist
    },
    lbCreditsPlan() {
      return this.$store.state.header.lbCreditsPlan
    }
  },
  data: function() {
    return {
      profileList: [],
      loading: true,
      bulkLoader: false,
      showPopup: false,
      upgradePopupType: null,
      showReviewPopup: false,
      getCheckedContacts: [],
      getLinkedInMap: {},
      selectContacts: false,
      requestId: null,
      showLinkedInConnect: false,
      showActivationPopup: false,
      showCreditLimitPopup: false
    }
  },
  created() {
    this.$store.state.linkedin.bulk.contacts = null
  },
  components: {
    'Contact-Card': ContactCard,
    'V-Button': button,
    'Review-Popup': ReviewPopup,
    'Upgrade-Popup': UpgradePopup,
    'Create-List': CreateList,
    // 'Create-List-Floating-Label': CreateListFloatingLabel,
    'Linkedin-Connect-Popup': LinkedinConnectVue,
    // 'Crm-Export': CrmExport,
    // 'Crm-Export-Loader': CrmExportLoader,
    // 'Help-Section': helpSection,
    'Activation-Popup': ActivationPopup,
    'Credit-Limit-Popup': CreditLimitPopup,
    CheckBox: Checkbox
  },
  methods: {
    closeListOutside() {
      this.$emit('closeListOutside', true)
    },
    getContactData(el) {
      if (el && el.linkedinId && this.$store.state.linkedin.bulk.contacts) {
        return this.$store.state.linkedin.bulk.contacts[el.linkedinId]
      }
      return el
    },
    canShowCheckBox(el) {
      return this.getContactData(el) ? this.getContactData(el).email : false
    },
    enrichProfileData(profiles) {
      this.loading = true
      this.resetSelectContact()
      window.scrollTo(0, 0)
      let data = {}
      data['profiles'] = profiles
      data['currentUrl'] = ''
      post('li/adv/v2/profiles.htm', data)
        .then(response => {
          if (response.status == 200) {
            this.requestId = response.headers.get('requestId')
            response
              .json()
              .then(res => {
                for (let profile of profiles) {
                  if (profile.linkedinId && res[profile.linkedinId]) {
                    res[profile.linkedinId].companyUrl = profile.companyUrl
                    res[profile.linkedinId].isVerifiedDomain =
                      profile.isVerifiedDomain
                    res[profile.linkedinId].isSalesNavigator =
                      profile.isSalesNavigator
                    res[profile.linkedinId].phone =
                      res[profile.linkedinId].phoneNumberFromVendor
                    res[profile.linkedinId].uniqueId = Math.ceil(
                      Math.random() * 1000
                    )
                    // Sales navigator string mismatch in variable name
                    this.$store.state.isSalesNavigator =
                      profile.isSalesNavigator
                  }
                }
                this.$store.state.linkedin.bulk.contacts = res
                this.loading = false
              })
              .catch(e => {
                this.loading = false
                console.log('err: ' + e)
              })
          } else {
            this.loading = false
            console.log('status: ' + response.status)
          }
        })
        .catch(e => {
          this.loading = false
          console.log('error: ' + e)
        })
    },
    getDataForMixpanel() {
      let emailCount = 0
      this.$store.state.linkedin.bulk.unique_id = sharedFunction.generateUUID()
      Object.values(this.$store.state.linkedin.bulk.contacts).forEach(c => {
        if (c.email) {
          emailCount++
        }
      })
      const dataMap = {
        totalContacts: this.profileList.length,
        maskedEmail: emailCount,
        uniqueId: this.$store.state.linkedin.bulk.unique_id,
        isSalesNavigator: this.$store.state.isSalesNavigator
      }
      return dataMap
    },
    fireMixpanel(eventName, dataMap) {
      sharedFunction.track(eventName, dataMap, this.$store.state)
    },
    findAllEmail() {
      const dataMap = this.getDataForMixpanel()
      this.fireMixpanel(MxEvent.GET_ALL_CLICKED, dataMap)
      this.bulkLoader = true
      let contactIds = []
      let contactIdsMap = {}
      if (this.getCheckedContacts.length > 0) {
        contactIds = this.getCheckedContacts
        contactIdsMap = this.getLinkedInMap
      } else {
        for (let key in this.$store.state.linkedin.bulk.contacts) {
          if (
            this.$store.state.linkedin.bulk.contacts[key] &&
            this.$store.state.linkedin.bulk.contacts[key].mcId
          ) {
            contactIds.push(this.$store.state.linkedin.bulk.contacts[key].mcId)
            const liId = this.$store.state.linkedin.bulk.contacts[key]
              .linkedinId
            contactIdsMap[
              this.$store.state.linkedin.bulk.contacts[key].mcId
            ] = liId
          }
        }
      }
      const listName = this.$store.state.linkedin.list.selectedList
      const data = {
        contactIds,
        listName,
        sn: this.$store.state.isSalesNavigator
      }
      post(HttpUrl.addContactToList, data)
        .then(response => {
          this.resetSelectContact()
          this.bulkLoader = false
          switch (response.status) {
            case 200:
              response.json().then(res => {
                const previousCredits = this.$store.state.header.credits
                let emailFound = res.emails.length
                let successMsg = `${
                  emailFound > 0 ? 'Successfully added ' + emailFound : 'No'
                } contact${
                  emailFound > 1 || emailFound === 0 ? 's' : ''
                } to the list ${listName}.`
                sharedFunction.showNotificationMsg(successMsg, 2000)
                const contacts = res.emails
                if (this.lbCreditsPlan)
                  this.$store.state.header.credits = res.creditsLeft
                else this.$store.state.header.views = res.creditsLeft
                for (let contactInfo of contacts) {
                  const liId = contactIdsMap[contactInfo.mcId]
                  this.$store.state.linkedin.bulk.contacts[liId].email =
                    contactInfo.email
                  this.$store.state.linkedin.bulk.contacts[
                    liId
                  ].contactAlreadyOwned = true
                }
                if (
                  checkAndShowG2ReviewPopup(
                    this.$store.state.header.userType,
                    previousCredits,
                    res.creditsLeft
                  )
                ) {
                  this.enableReviewPopup()
                }
              })
              break
            case 419:
              // views exhausted
              this.showUpgradePopup('views')
              break
            case 423:
              // bulk views exhausted
              this.showUpgradePopup('bulk')
              break
            case 402:
              this.loading = false
              this.showUpgradePopup('daily_limit')
              break
            case 417:
              this.showLinkedInConnect = true
              break
            case 406:
              this.showUpgradePopup('li_connect_skip')
              break
            case 412:
              this.loading = false
              this.showActivationError()
              break
            case 420:
              this.setShowCreditLimitPopup()
              break
            case 400:
              this.loading = false
              this.showUpgradePopup('fair_usage_limit')
          }
        })
        .catch(e => {
          console.log('error :' + e)
          this.bulkLoader = false
        })
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    onValueChange(ele) {
      this.getLinkedInMapContact(this.getContactData(ele))
    },
    getLinkedInMapContact(data) {
      const index = this.getCheckedContacts.indexOf(data.mcId)
      if (index === -1) {
        this.getCheckedContacts.push(data.mcId)
        this.getLinkedInMap[data.mcId] = data.linkedinId
      } else {
        this.getCheckedContacts.splice(index, 1)
        delete this.getLinkedInMap[data.mcId]
      }

      if (this.totalContactExist === this.getCheckedContacts.length) {
        this.selectContacts = true
      } else {
        this.selectContacts = false
      }
    },
    checkContactSelected() {
      if (this.selectContacts) {
        this.getCheckedContacts = []
        this.getLinkedInMap = {}
      } else {
        Object.values(this.$store.state.linkedin.bulk.contacts).forEach(c => {
          if (c && c.email) {
            if (this.getCheckedContacts.indexOf(c.mcId) === -1) {
              this.getCheckedContacts.push(c.mcId)
              this.getLinkedInMap[c.mcId] = c.linkedinId
            }
          }
        })
      }
      this.selectContacts = !this.selectContacts
    },
    resetSelectContact() {
      this.getCheckedContacts = []
      this.getLinkedInMap = {}
      this.selectContacts = false
    },
    openCreateList() {
      this.showCreateList = true
    },
    clickOutsideDom() {
      //console.log($event)
    },
    trackBulkProfileLoad(profilesInfo) {
      const { profiles = [], isSalesNavigator = false } = profilesInfo || {}
      const linkedinUrls = profiles.map(item =>
        item.linkedinId ? item.linkedinId : ''
      )
      sharedFunctions.track(
        isSalesNavigator
          ? MxEvent.bulkContactViewedSN
          : MxEvent.bulkContactViewed,
        {
          linkedinUrls
        },
        this.$store.state
      )
    },
    showActivationError() {
      this.showActivationPopup = true
    },
    updateEmail(res, data) {
      this.errorMsg = null
      if (data && data.linkedinId && res) {
        const id = data.linkedinId
        this.$store.state.linkedin.bulk.contacts[id].email = res.email
        this.$store.state.linkedin.bulk.contacts[id].contactAlreadyOwned = true
        this.$store.state.linkedin.bulk.contacts[id].emailDeliverability =
          res.emailDeliverability
        this.$store.state.linkedin.bulk.contacts[id].mcId = res.masterContactId
      }
    },
    updatePhone(phone, data) {
      const id = data.linkedinId
      this.$store.state.linkedin.bulk.contacts[id].phone = phone
    },
    findEmailCallback(response, autoTrigger, data) {
      let errorMessage = ''

      //PARAMS -> linkedinId
      const dataMap = {
        uniqueId: this.$store.state.linkedin.bulk.unique_id,
        isSalesNavigator: this.$store.state.isSalesNavigator
      }
      if (response && response.statusCode === '200') {
        sharedFunctions.track(
          MxEvent.bulkContactEmailFound,
          dataMap,
          this.$store.state
        )
        this.updateEmail(response.response, data)
        if (autoTrigger) this.$store.state.linkedin.autoTrigger = true
        //get email is automatically clicked
      } else if (response && response.statusCode === '100') {
        errorMessage = sharedFunctions.getRespectiveErrorMsg(response)
        dataMap.error = errorMessage
        sharedFunctions.track(
          MxEvent.bulkContactEmailNotFound,
          dataMap,
          this.$store.state
        )
      } else {
        dataMap.error = 'Server Error'
        sharedFunctions.track(
          MxEvent.bulkContactEmailNotFound,
          dataMap,
          this.$store.state
        )
      }

      return errorMessage
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dis-none {
  display: none;
}
h3 {
  padding: 40px 0 0;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
  }
}
.contact-card-section {
  // overflow: hidden;
  width: 100%;
}
.body {
  // border: 1px solid $primary-color;
  position: relative;
  // top: 51px;
  z-index: 0;
  .max-height {
    height: -webkit-fill-available;
  }
}

.bulk__contact__List {
  padding-top: 48px;
  &.no_space {
    padding-top: 0;
  }
  li {
    border-bottom: 1px solid #e0e4ea;
    display: flex;
    align-items: flex-start;
  }
}

.blur-li {
  position: fixed;
  bottom: 0;
  width: 100%;
  justify-content: center;
  background: #f8f9fe;
  border-radius: 0px 0px 12px 12px;
  padding: 35px 25px;
  margin-top: 10px;
  button {
    padding: 14px;
    width: 80%;
    font-size: 14px;
  }
}

.list-section::v-deep {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .create-list {
    width: 100%;
    background: #fff;
    .dropdown__list {
      top: auto;
      bottom: calc(100% + 8px);
      .sharp__pointer {
        top: auto;
        bottom: -6px;
        transform: rotate(225deg);
      }
    }
  }
}
.blur-li::v-deep .bulk-get-email-but {
  padding: 8px 0px;
  font-size: 14px;
  width: 100%;
}
.sel-all-section {
  display: flex;
  padding: 10px 25px;
}
.filter-section {
  position: fixed;
  width: 100%;
  z-index: 2;
  background: linear-gradient(
    to right,
    lighten(#fad6e8, 5%),
    lighten(#d4dbfd, 5%)
  );
  .flex-end {
    justify-content: flex-end !important;
  }
}

.list-loader::v-deep {
  width: 100%;
  z-index: 1;
  position: fixed;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    to right,
    lighten(#fad6e8, 5%),
    lighten(#d4dbfd, 5%)
  );

  .list-loader-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 0 25px;
    .checkbox-label {
      width: 150px;
    }
  }
}
.loader-check-box {
  padding: 9px;
  border-radius: 3px;
}
.chk-box-space {
  margin: 15px 0px 15px 10px;
}
</style>
